import { render, staticRenderFns } from "./NotificationEditModal.vue?vue&type=template&id=10e92c5b&"
import script from "./NotificationEditModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports